module.exports = __webpack_public_path__ + "img/blue_090.817433db.png";